import ReviewDeposit from 'features/rdc/screens/ReviewDeposit/ReviewDeposit';
import React from 'react';

export default function Page() {
  return <ReviewDeposit />;
}
